import React from 'react';
import ConversionsContainer from '../components/conversions.container';

/** The XML history: everything the converter has produced, and the file it produced. */
const ConversionListPage: React.FC = () => <ConversionsContainer />;

export default ConversionListPage;
